module.exports = __webpack_public_path__ + "static/media/webdev.b4758e59.jpg";